import { render, staticRenderFns } from "./ElementKeyboardShortcuts.vue?vue&type=template&id=3d86eead&scoped=true&"
import script from "./ElementKeyboardShortcuts.vue?vue&type=script&lang=js&"
export * from "./ElementKeyboardShortcuts.vue?vue&type=script&lang=js&"
import style0 from "./ElementKeyboardShortcuts.vue?vue&type=style&index=0&id=3d86eead&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d86eead",
  null
  
)

export default component.exports